module.exports = __webpack_public_path__ + "static/media/sumerMap.49f01785.png";